import React from "react";
import Sortings from "../../Misc/Sortings";
export default function ReportSortings(props) {
  const sortings = [
    {
      id: "byTypeAsc",
      active: false,
      title: "По типу",
      value: ["typecode ASC"],
    },
    {
      id: "byLabelAsc",
      active: false,
      title: "По алфавиту",
      value: ["label ASC"],
    },
  ];

  return <Sortings changeFn={props.handleSortings} sortings={sortings} />;
}
